/**
 * Text input widget.
 */

import type { FunctionComponent } from 'preact'

interface TextInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
  type?: 'text' | 'email' | 'url'
}

export const TextInput: FunctionComponent<TextInputProps> = ({
  value,
  onChange,
  placeholder,
  disabled,
  type = 'text',
}) => {
  return (
    <input
      type={type}
      class="syv-input"
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      onInput={(e) => onChange((e.target as HTMLInputElement).value)}
    />
  )
}
